import { AbstractControlOptions, ValidatorFn } from '@angular/forms';

export enum FormActionType {
  Add = 'Add',
  Update = 'Update',
  View = 'View'
}

export type FormGroupConfig<T> = {
  [P in keyof T]: [
    T[P] | { value: T[P]; disabled: boolean },
    AbstractControlOptions | ValidatorFn | ValidatorFn[]
  ];
};

// https://tomastrajan.medium.com/angular-reactive-sub-forms-type-safe-without-duplication-dbd24225e1e8
